<template>
    <nav role="navigation" class="mainnav" v-if="navLinks && navLinks.length > 0" :class="{ 'menu-open': navOpen }">
        <ul class="root-menu container flex">
            <nav-menu-item :model="lnk" v-for="lnk in navLinks" :key="lnk.url"></nav-menu-item>
        </ul>
        <slot></slot>
    </nav>
    <Teleport to="body">
        <span class="open-cover"></span>
    </Teleport>
</template>

<script lang="js">
    import { mapGetters } from 'vuex'

    import NavMenuItem from './NavMenuItem.vue'
    export default {
        name: "nav-menu",
        components: { NavMenuItem },
        props: {
            navOpen: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        computed: {
            ...mapGetters({ navLinks: 'nav/navLinks' })
        }
    };
</script>

<style>
    nav.mainnav {
        position: absolute;
        top: calc(var(--header-height) + 2rem);
        left: 20%;
        width: 60%;
        z-index: -1;
        border-radius: 1em;
        background-color: var(--green1);
        opacity: 0;
        overflow-y: auto;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -ms-transform: scale(.75);
        -o-transform: scale(.75);
        -webkit-transform: scale(.75);
        transform: scale(.75);
        -moz-transition: opacity .2s linear .1s, transform .2s linear .1s;
        -o-transition: opacity .2s linear .1s, transform .2s linear .1s;
        -webkit-transition: opacity .2s linear .1s, transform .2s linear .1s;
        transition: opacity .2s linear .1s, transform .2s linear .1s;
    }

    nav.mainnav ul.flex {
        margin: 0.8125rem 0;
        padding: 0;
        list-style-type: none;
    }

    span.open-cover {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: block;
        background-color: rgba(0,0,0,0);
        z-index: -1;
        -moz-transition: background-color .2s linear, z-index 0s linear .2s;
        -o-transition: background-color .2s linear, z-index 0s linear .2s;
        -webkit-transition: background-color .2s linear, z-index 0s linear .2s;
        transition: background-color .2s linear, z-index 0s linear .2s;
    }

    body.menu-open span.open-cover {
        background-color: rgba(39,43,33,0.8);
        -moz-transition: background-color .1s linear;
        -o-transition: background-color .1s linear;
        -webkit-transition: background-color .1s linear;
        transition: background-color .1s linear;
        z-index: 2;
    }

    /*Open*/
    nav.mainnav.menu-open {
        z-index: 3;
        opacity: 1;
        -ms-transform: scale(1);
        -o-transform: scale(1);
        -webkit-transform: scale(1);
        transform: scale(1);
        -moz-transition: opacity .2s linear, transform .1s linear;
        -o-transition: opacity .2s linear, transform .1s linear;
        -webkit-transition: opacity .2s linear, transform .1s linear;
        transition: opacity .2s linear, transform .1s linear;
    }


    @media screen and (min-width: 800px) {

        nav.mainnav {
            position: static;
            background-color: transparent;
            opacity: 1;
            z-index: 3;
            overflow-y: visible;
            top: 0;
            left: 0;
            width: 100%;
            -ms-transform: scale(1);
            -o-transform: scale(1);
            -webkit-transform: scale(1);
            transform: scale(1);
        }

            nav.mainnav.menu-open {
                margin-bottom: 0;
                overflow: visible;
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
            }

            nav.mainnav ul.flex {
                margin: 0 auto;
                align-items: flex-start;
                justify-content: center;
                -ms-flex-wrap: nowrap;
                -webkit-flex-wrap: nowrap;
                flex-wrap: nowrap;
            }

        span.open-cover {
            display: none;
        }

    }

</style>